// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2oL9F","inner":"Form_inner__2sg5b","range":"Form_range__2xpb-","name":"Form_name__30XtJ","actions":"Form_actions__34t5B"};